var _circle, _path, _circle2, _circle3, _circle4, _path2, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParts = function SvgParts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.875,
    cy: 4.275,
    r: 0.625,
    fill: "#101010"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#101010",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M6.35 4.275a1.475 1.475 0 1 1-2.95 0 1.475 1.475 0 0 1 2.95 0Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 8.625,
    r: 0.75,
    fill: "#101010"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 8.625,
    r: 2.1,
    stroke: "#101010",
    strokeLinecap: "round",
    strokeWidth: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 13.4,
    r: 4.1,
    stroke: "#101010",
    strokeLinecap: "round",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#101010",
    strokeWidth: 0.8,
    d: "m3.75 6.65 1 3.25M7.5 3.65l5.25 2.25M14 12.9l1.011-.987"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 13.4,
    r: 1,
    fill: "#101010"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 11.15,
    r: 0.5,
    fill: "#101010"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.768,
    cy: 12.4,
    r: 0.5,
    fill: "#101010",
    transform: "rotate(-60 6.768 12.4)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.768,
    cy: 14.4,
    r: 0.5,
    fill: "#101010",
    transform: "rotate(-120 6.768 14.4)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 15.65,
    r: 0.5,
    fill: "#101010",
    transform: "rotate(-180 8.75 15.65)"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.732,
    cy: 14.4,
    r: 0.5,
    fill: "#101010",
    transform: "rotate(120 10.732 14.4)"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.732,
    cy: 12.4,
    r: 0.5,
    fill: "#101010",
    transform: "rotate(60 10.732 12.4)"
  })));
};
export default SvgParts;